import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { RouteRecordName } from 'vue-router';
import type { EnhancedRouteLocation } from '@/router/types';

export const useRouteCacheStore = defineStore('route-cache', () => {
  const routeCaches = ref<RouteRecordName[]>([]);

  const addRoute = (route: EnhancedRouteLocation) => {
    if (routeCaches.value.includes(route.name)) {
      return;
    }

    if (route?.meta?.keepAlive) {
      routeCaches.value.push(route.name);
      console.log('🍎 routeCaches', routeCaches.value);
    }
  };

  const removeRoute = (routeName: RouteRecordName) => {
    const index = routeCaches.value.indexOf(routeName);
    if (index > -1) {
      routeCaches.value.splice(index, 1);
    }
  };

  const clearCache = () => {
    routeCaches.value = [];
  };

  return {
    routeCaches,
    addRoute,
    removeRoute,
    clearCache,
  };
});
